// scss
import "./index.scss";

import {useState} from "react";
import TemplateItemsData from "../../assets/data/TemplateItemsData";
import TemplateTab from "../../components/TemplateTab";
import TemplateGroup from "../../components/TemplateGroup";

const Template = () => {

    // 重組內頁使用的tab陣列，添加“全部模板”
    const templateCategories = ["全部模版", ...new Set(TemplateItemsData.map((item) => item.template_category_name))];

    // 並且把 分類陣列存成categories，給tab辨別使用
    const [categories] = useState(templateCategories);
    // 點選的項目紀錄，紀錄tab active使用
    const [templateCurrentItem, setTemplateCurrentItem] = useState(0);

    // 內頁『預設:全部模板』，全部列出來（順序 = 陣列 reverse，標籤同步依此順序）
    const [templateContents, setTemplateContents] = useState([...TemplateItemsData].reverse());

    // gtm使用，判斷篩選項目
    const [selectedName, setSelectedName] = useState(true);
    const filterItems = (category) => {
        // 重新撈資料篩選
        const newPageContents = TemplateItemsData.filter((item) => item.template_category_name === category);
        // 記得最新的要在最上方！所以要反轉reverse
        setTemplateContents([...newPageContents].reverse());
        setSelectedName(false);

        // 選擇全部模板，則將全部資料塞回去，記得也要反轉！
        if (category === "全部模版") {
            setTemplateContents([...TemplateItemsData].reverse());
            setSelectedName(true); //判斷為：全部模板
            return;
        }
    };

    return (
        <>
            {/* 推薦模版 */}
            <div className="template-wrap">
                <div className="template-content">
                    <TemplateTab
                        categories={categories}
                        filterItems={filterItems}
                        templateCurrentItem={templateCurrentItem}
                        setTemplateCurrentItem={setTemplateCurrentItem}
                    />
                    <TemplateGroup selectedName={selectedName} templateContents={templateContents} />
                </div>
            </div>
        </>
    );
};

export default Template;
